import { Accordion, AccordionContent, AccordionHeader, AccordionItem, AccordionTrigger, Markdown } from '@ibsys/kit';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { splitHelpSections } from './helpSections';

/** Разделы справки по синтаксису правила извлечения — общее содержимое окна на любом экране. */
export const RuleInfoSections: FC = () => {
  const { t } = useTranslation('attributes');

  const content = t('ruleInfo.content');
  const sections = useMemo(() => splitHelpSections(content), [content]);

  return (
    <Accordion type="multiple" defaultValue={sections.map((section) => section.id)}>
      {sections.map((section) => (
        <AccordionItem key={section.id} value={section.id} className="border-0">
          {/* Заголовок раздела остаётся заголовком для чтения с экрана и рендерится разметкой: в нём есть код */}
          <AccordionHeader>
            <AccordionTrigger className="py-3 text-sm font-medium [&_p]:mb-0">
              <Markdown>{section.title}</Markdown>
            </AccordionTrigger>
          </AccordionHeader>
          {/* Длинные примеры правил переносятся, а не уезжают в горизонтальную прокрутку: справку сверяют с полем ввода.
              Отступ строчного кода внутри блока снят: у перенесённого примера его получала только первая строка */}
          <AccordionContent className="text-sm [&_pre]:break-words [&_pre]:whitespace-pre-wrap [&_pre_code]:p-0">
            <Markdown>{section.body}</Markdown>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
